export const DealerProfileSettingsActionTypes = {
  RESET_ALL_SUBMISSION_STATES: 'RESET_ALL_SUBMISSION_STATES',
  SET_DEALER_ID_BEING_EDITED: 'SET_DEALER_ID_BEING_EDITED',

  SUBMIT_DEALER_PROFILE_SETTINGS_BEGIN: 'SUBMIT_DEALER_PROFILE_SETTINGS_BEGIN',
  SUBMIT_DEALER_PROFILE_SETTINGS_FAIL: 'SUBMIT_DEALER_PROFILE_SETTINGS_FAIL',
  SUBMIT_DEALER_PROFILE_SETTINGS_SUCCESS:
    'SUBMIT_DEALER_PROFILE_SETTINGS_SUCCESS',

  SET_INITIAL_DEALER_PROFILE_SETTINGS_OPTIONS:
    'SET_INITIAL_DEALER_PROFILE_SETTINGS_OPTIONS',
  SET_SAVE_CHANGES_MODAL_IS_VISIBLE: 'SET_SAVE_CHANGES_MODAL_IS_VISIBLE',
  SET_SELECTED_DEALER_PROFILE_SETTINGS_CATEGORY_TAB:
    'SET_SELECTED_DEALER_PROFILE_SETTINGS_CATEGORY_TAB',
  SET_SHOW_CONFIRMATION_ANIMATION: 'SET_SHOW_CONFIRMATION_ANIMATION',
  TOGGLE_ALL_DEALER_PROFILE_SETTINGS_OPTIONS:
    'TOGGLE_ALL_DEALER_PROFILE_SETTINGS_OPTIONS',
  TOGGLE_APPLY_CHANGES_TO_ALL: 'TOGGLE_APPLY_CHANGES_TO_ALL',
  UPDATE_PROFILE_SETTING_FOR_DEALER: 'UPDATE_PROFILE_SETTING_FOR_DEALER',
};
